//export const API_URL = "http://localhost:8080/Meteo_cnrs_war/api/meteo/"
export const API_URL = "https://websie.cefe.cnrs.fr/meteo-ws/api/meteo/"

